import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
// import dayjs from 'dayjs'
import { paginationInit, formatMessageNew, downLoadFileBlob } from '@/utils/common'
import {
  getAllDropDownList,
  getRsoRateReportlList,
  exportRsoRateReport
} from '../../../services/rfid/defectiveReturn/defectiveReturn'
import { Button, Card, Tabs, Input, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import ActionBar from '@/components/table/ActionBar'
import { formatEndTime, formatStartTime } from '../../../utils/common'

const searchItemSpan = { xl: 8, xxl: 8 }
const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 }
}
const dateFormat = 'YYYY-MM-DD'
const tabKeys = ['1', '2', '3']

const renderColumn = text => {
  return <div className="word_break_all">{text}</div>
}

const SkipRejectRateReport = () => {
  const mounting = useRef(false)
  const formRef = useRef(null)
  const searchInput = useRef(null)
  const languageState = useSelector(state => state.commonStore.language)
  const [activeKey, setActiveKey] = useState('1')
  const [needRequsestList, setNeedRequsestList] = useState([])
  // By RSO
  const [rsoTableList, setRsoTableList] = useState([])
  const [rsoPagination, setRsoPagination] = useState(paginationInit)
  const [rsoQueryFlag, setRsoQueryFlag] = useState(false)
  // BY Product Code
  const [productTableList, setProductTableList] = useState([])
  const [productPagination, setProductPagination] = useState(paginationInit)
  const [productQueryFlag, setProductQueryFlag] = useState(false)
  // BY Account
  const [accountTableList, setAccountTableList] = useState([])
  const [accountPagination, setAccountPagination] = useState(paginationInit)
  const [accountQueryFlag, setAccountQueryFlag] = useState(false)

  const [filtersObj, setFiltersObj] = useState({})

  const handleSearch = confirm => {
    mounting.current = true
    confirm()
  }

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
        <Input
          ref={searchInput}
          size="small"
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(confirm)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(confirm, selectedKeys, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
          >
            Search
          </Button>
          <Button onClick={() => clearFilters && clearFilters()} size="small">
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close()
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined
        }}
      />
    )
  })

  const searchList = [
    {
      type: 'timeRange',
      label: 'languageObj.defectiveReturnLocale.nikeSubmissionDate',
      key: 'toDate',
      format: dateFormat,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: [],
      spans: searchItemSpan
    }
  ]
  const commonCloumns = [
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.submitQty'),
      dataIndex: 'submitQty',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.actualScanQty'),
      dataIndex: 'actualScanQty',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.overdueQty'),
      dataIndex: 'overdueQty',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.skipRate'),
      dataIndex: 'skipRate',
      render: text => {
        // 复数的时候，字体颜色为红色
        return <div style={{ color: text.includes('-') ? 'red' : '' }}>{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rejectRate'),
      dataIndex: 'rejectRate',
      render: renderColumn
    }
  ]
  const initRsoColumns = [
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rso'),
      dataIndex: 'rso',
      ...getColumnSearchProps('rso')
    },
    ...commonCloumns
  ]
  const initProductColumns = [
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.productCode'),
      dataIndex: 'productCode',
      ...getColumnSearchProps('productCode')
    },
    ...commonCloumns
  ]
  const initAccountColumns = [
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.account'),
      dataIndex: 'account',
      render: renderColumn,
      filters: [],
      filterSearch: true
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rsoSoldTo'),
      dataIndex: 'soldTo',
      ...getColumnSearchProps('soldTo')
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.bigGroup'),
      dataIndex: 'bigGroup',
      ...getColumnSearchProps('bigGroup')
    },
    ...commonCloumns
  ]

  const [rsoColumns, setRsoColumns] = useState(initRsoColumns)
  const [productColumns, setProductColumns] = useState(initProductColumns)
  const [accountColumns, setAccountColumns] = useState(initAccountColumns)

  useEffect(() => {
    getAccountList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (mounting.current) searchRsoDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rsoQueryFlag])

  useEffect(() => {
    if (mounting.current) searchProductDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productQueryFlag])

  useEffect(() => {
    if (mounting.current) searchAccountDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountQueryFlag])

  useEffect(() => {
    const newRsoColumns = rsoColumns.map(item => {
      if (item.dataIndex === 'rso') {
        return {
          ...item,
          filteredValue: filtersObj.rso ? filtersObj.rso : null
        }
      }
      return item
    })
    const newProductColumns = productColumns.map(item => {
      if (item.dataIndex === 'productCode') {
        return {
          ...item,
          filteredValue: filtersObj.productCode ? filtersObj.productCode : null
        }
      }
      return item
    })
    const newAccountColumns = accountColumns.map(item => {
      const newItem = { ...item }
      switch (item.dataIndex) {
        case 'account':
          newItem.filteredValue = filtersObj.account || null
          break
        case 'soldTo':
          newItem.filteredValue = filtersObj.soldTo || null
          break
        case 'bigGroup':
          newItem.filteredValue = filtersObj.bigGroup || null
          break
        default:
          break
      }
      return newItem
    })
    setAccountColumns(newAccountColumns)
    setProductColumns(newProductColumns)
    setRsoColumns(newRsoColumns)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersObj])

  const getAccountList = () => {
    getAllDropDownList({ type: 1 }).then(res => {
      const resultData = res.resultData || []
      const filterList = resultData.map(item => ({ text: item, value: item }))
      const columns = accountColumns.map(item => {
        if (item.dataIndex === 'account') item.filters = filterList
        return item
      })
      setAccountColumns(columns)
    })
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      startToDate: formatStartTime(info.toDate),
      endToDate: formatEndTime(info.toDate),
      isChinese: languageState === 'zh_CN'
    }
    return params
  }

  const getReportist = (otherParams, cb) => {
    const params = {
      ...getParams(),
      ...otherParams,
      type: activeKey
    }
    return getRsoRateReportlList(params).then(res => {
      const dt = res.resultData
      cb && cb(dt)
    })
  }

  const requestTabData = (activeKey, needRequsestList) => {
    if (!needRequsestList.includes(activeKey)) return
    const list = needRequsestList.filter(item => item !== activeKey)
    setNeedRequsestList(list)
    switch (activeKey) {
      case '1':
        const rsoPg = { ...rsoPagination, currentPage: 1 }
        setRsoPagination(rsoPg)
        setRsoQueryFlag(!rsoQueryFlag)
        break
      case '2':
        const productPg = { ...productPagination, currentPage: 1 }
        setProductPagination(productPg)
        setProductQueryFlag(!productQueryFlag)
        break
      case '3':
        const accountPg = { ...accountPagination, currentPage: 1 }
        setAccountPagination(accountPg)
        setAccountQueryFlag(!accountQueryFlag)
        break
      default:
        break
    }
  }

  // 点击查询按钮
  const searchDataBtn = () => {
    mounting.current = true
    setNeedRequsestList(tabKeys)
    requestTabData(activeKey, tabKeys)
  }

  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    setFiltersObj({})
    searchDataBtn()
  }

  // By RSO
  const searchRsoDataFun = () => {
    setRsoTableList([])
    const params = {
      rso: filtersObj.rso?.length > 0 ? filtersObj.rso[0] : undefined,
      size: rsoPagination.pageSize,
      pageNo: rsoPagination.currentPage
    }
    getReportist(params, dt => {
      const pg = { ...rsoPagination, total: dt.total }
      setRsoTableList(dt.records)
      setRsoPagination(pg)
    })
  }

  const handleRsoTableChange = (pagina, filters) => {
    const params = {
      ...rsoPagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setRsoPagination(params)
    setRsoQueryFlag(!rsoQueryFlag)
    setFiltersObj({ ...filtersObj, ...filters })
  }

  // By Product Code
  const searchProductDataFun = () => {
    setProductTableList([])
    const params = {
      productCode: filtersObj.productCode?.length > 0 ? filtersObj.productCode[0] : filtersObj.productCode,
      size: productPagination.pageSize,
      pageNo: productPagination.currentPage
    }
    getReportist(params, dt => {
      const pg = { ...productPagination, total: dt.total }
      setProductTableList(dt.records)
      setProductPagination(pg)
    })
  }

  const handleProductTableChange = (pagina, filters) => {
    const params = {
      ...productPagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setProductPagination(params)
    setProductQueryFlag(!productQueryFlag)
    setFiltersObj({ ...filtersObj, ...filters })
  }

  // By Account
  const searchAccountDataFun = () => {
    setAccountTableList([])
    const { account, soldTo, bigGroup } = filtersObj
    const params = {
      account,
      soldTo: soldTo?.length > 0 ? soldTo[0] : undefined,
      bigGroup: bigGroup?.length > 0 ? bigGroup[0] : undefined,
      size: accountPagination.pageSize,
      pageNo: accountPagination.currentPage
    }
    getReportist(params, dt => {
      const pg = { ...accountPagination, total: dt.total }
      setAccountTableList(dt.records)
      setAccountPagination(pg)
    })
  }

  const handleAccountTableChange = (pagina, filters) => {
    const params = {
      ...accountPagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setAccountPagination(params)
    setAccountQueryFlag(!accountQueryFlag)
    setFiltersObj({ ...filtersObj, ...filters })
  }

  const downLoadFun = () => {
    // TODO
    const params = {
      ...getParams(),
      type: activeKey
    }
    switch (activeKey) {
      case '1':
        params.rso = filtersObj.rso?.length > 0 ? filtersObj.rso[0] : undefined
        break
      case '2':
        params.productCode = filtersObj.productCode?.length > 0 ? filtersObj.productCode[0] : filtersObj.productCode
        break
      case '3':
        params.account = filtersObj.account?.length > 0 ? filtersObj.account : undefined
        params.soldTo = filtersObj.soldTo?.length > 0 ? filtersObj.soldTo[0] : undefined
        params.bigGroup = filtersObj.bigGroup?.length > 0 ? filtersObj.bigGroup[0] : undefined
        break
      default:
        break
    }
    exportRsoRateReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const hadleTabChange = key => {
    setActiveKey(key)
    requestTabData(key, needRequsestList)
  }
  const tabItems = [
    {
      key: '1',
      label: 'By RSO',
      children: (
        <div>
          <ActionBar onDownload={downLoadFun} />
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={rsoTableList}
            columns={rsoColumns}
            iconTop={20}
            // 独一无二的标识，不能重复
            columnsKey="rsoRateReportCoumns"
            pagination={rsoPagination}
            onChange={handleRsoTableChange}
          />
        </div>
      )
    },
    {
      key: '2',
      label: 'By Product Code',
      children: (
        <div>
          <ActionBar onDownload={downLoadFun} />
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={productTableList}
            columns={productColumns}
            // 独一无二的标识，不能重复
            columnsKey="productRateReportCoumns"
            pagination={productPagination}
            onChange={handleProductTableChange}
          />
        </div>
      )
    },
    {
      key: '3',
      label: 'By Account',
      children: (
        <div>
          <ActionBar onDownload={downLoadFun} />
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={accountTableList}
            columns={accountColumns}
            // 独一无二的标识，不能重复
            columnsKey="accountRateReportCoumns"
            pagination={accountPagination}
            onChange={handleAccountTableChange}
          />
        </div>
      )
    }
  ]

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            layout={formItemLayout}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <Tabs items={tabItems} defaultActiveKey="1" onChange={hadleTabChange} />
        </div>
      </Card>
    </div>
  )
}
export default SkipRejectRateReport
